<template>
  <div
    :class="{
      'message-card': true,
      'success-message': type == 'success',
      'error-message': type == 'error',
      unread: !isRead
    }"
  >
    <div class="message-icon">
      <component :is="icon" :size="36" />
    </div>
    <div class="message-delete">
      <close-icon :size="18" @click="remove" />
    </div>
    <div class="message-text">
      <p class="message-title">{{ title }}</p>
      <p>{{ message }}</p>
      <p class="message-help">{{ help }}</p>
    </div>
    <span class="time-field">{{ dateTimeLine }}</span>
  </div>
</template>

<script>
/** Icons */
import CloseIcon from "vue-material-design-icons/Close.vue";
import ShareVariant from "vue-material-design-icons/ShareVariant.vue";
import PanoramaIcon from "vue-material-design-icons/Panorama.vue";
import MovieEdit from "vue-material-design-icons/MovieEdit.vue";
import BellIcon from "vue-material-design-icons/Bell.vue";

// @group Notifications
// Notification card
export default {
  name: "Message",
  components: {
    CloseIcon
  },
  props: {
    // UTC date and time when notification was sent
    datetime: {
      type: Date,
      required: true
    },
    // Mangomolo admin timezone
    timezone: {
      type: String,
      default: "UTC"
    },
    // Notification title
    title: {
      type: String,
      default: "No title"
    },
    // Notification text
    message: {
      type: String,
      required: true
    },
    // Is notification read by user
    isRead: {
      type: Boolean,
      default: true
    },
    // Notification type (error, success)
    type: {
      type: String,
      default: "success",
      validator(val) {
        return ["error", "success"].includes(val);
      }
    },
    // Notification category (sharing, gif, edit_video, none)
    category: {
      type: String,
      default: "none",
      validator(val) {
        const categories = ["sharing", "gif", "edit_video", "none","conversion_video","conversion_audio","edit_audio"];
        return categories.includes(val);
      }
    }
  },
  computed: {
    // @vuese
    // String representing notification sent date and time
    dateTimeLine() {
      const options = {
        month: "short",
        day: "numeric",
        hour12: false,
        hour: "2-digit",
        minute: "2-digit",
        timeZone: this.timezone
      };
      return this.datetime.toLocaleString("en-US", options);
    },
    // @vuese
    // Notification icon component
    icon() {
      switch (this.category) {
        case "sharing":
          return ShareVariant;
        case "gif":
          return PanoramaIcon;
        case "edit_video":
          return MovieEdit;
        default:
          return BellIcon;
      }
    },
    // @vuese
    // Help message, that say user how to fix error (as example)
    help() {
      if (this.category === "sharing" && this.type === "error") {
        if (this.message.search("Facebook") >= 0) {
          if (this.message.search("#100") >= 0) {
            return "Please, try to add Mangomolo DVR Clipper application in your group settings to resolve this problem (https://www.facebook.com/help/261149227954100).";
          }
        }
      }

      return "";
    }
  },
  methods: {
    // @vuese
    // Remove message
    remove() {
      // User removed message
      this.$emit("removed");
    }
  }
};
</script>

<style scoped>
.message-card {
  display: grid;
  grid-template-columns: 15% 85%;
  grid-template-rows: 15px auto 18px;
  grid-template-areas:
    "noen delete"
    "icon message"
    "none datetime";

  margin: 1em 0 1em 0;
  padding: 1em;
  padding-left: 0;
  padding-right: 0.5em;
  padding-top: 0.5em;
  padding-bottom: 0.5em;
  border-radius: 10px;

  text-align: left;
  font-size: 1em;

  background-color: #777;

  transition: background-color 1s, color 1s;
}
.message-card.unread {
  /* background-color: #f7f272; */
  color: black;
}
.message-icon {
  grid-area: icon;
  align-self: center;
  justify-self: center;
  font-size: 4vh;
}
.message-delete {
  grid-area: delete;
  text-align: right;
}
.message-delete i {
  cursor: pointer;
}
.message-text {
  grid-area: message;
  overflow-wrap: break-word;
}
.message-text .message-title {
  /* font-family: Verdana, sans-serif; */
  font-size: 1rem;
  margin-block-start: 0;
  margin-block-end: 0;
}
.success-message .message-text .message-title {
  color: #5e5;
}
.error-message .message-text .message-title {
  color: #e00;
}

.message-text p {
  margin-block-start: 0.5em;
  /* font-family: "Times New Roman", serif; */
  font-size: 1rem;
}
.message-text .message-help {
  font-style: italic;
  font-size: 0.9rem;
  color: #ffb;
}
.time-field {
  /* font-family: "Times New Roman", serif; */
  font-size: 1rem;
  grid-area: datetime;
  text-align: right;
}

@media only screen and (max-height: 800px) and (max-width: 992px) {
  .message-icon {
    grid-area: icon;
    align-self: center;
    justify-self: center;
    font-size: 5vmax;
  }
}
</style>
